<template>
	<div>
		<!-- eslint-disable-next-line vue/no-mutating-props -->
		<v-dialog v-if="subscribeDialog" v-model="subscribeDialog" :max-width="size === 'sm' ? 295 : 364" :retain-focus="false" persistent>
			<div :class="`${theme}-theme`" @click="cancelEvent" @dblclick="cancelEvent">
				<div class="popup pa-0" :class="isMobile && 'overflow-auto'">
					<div class="popup-header pa-0 text-center">
						<div class="text-right pa-1">
							<v-btn class="close-icon" small icon @click="close">
								<v-icon size="18">{{ icons.mdiClose }}</v-icon>
							</v-btn>
						</div>
						<h4 class="fs--24 fw--600 popup-header-text">
							Subscriber Only <br />
							Sticker!
						</h4>
					</div>
					<div class="popup-body">
						<div class="popup-content">
							<template v-if="sticker.stickerType === 'TTS'">
								<AssetsTTS :sticker="sticker" :list="false" :popupMd="true" />
							</template>
							<template v-else>
								<v-img :src="getStickerImagePath(sticker)" width="100%" contain height="100"></v-img>
							</template>

							<div class="d-flex mt-5 mb-3">
								<div class="mr-1">
									<img src="@/assets/icons/icon_subonly.png" alt="Reward" />
								</div>
								<div class="text-center">
									<h4 class="fs--12 fw--600 popup-footer-text">
										You’ll need to be a channel subscriber to unlock this sticker!
									</h4>
								</div>
							</div>

							<v-btn
								block
								color="primary"
								class="fs--15 fw--600 mt-4 mb-3 action-btn text-uppercase"
								@click="subscribe">
								Subscribe Now
							</v-btn>
						</div>
					</div>
				</div>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import { useStore } from '@/store';
import { computed } from 'vue';
import { getStickerImagePath } from '@/utils/utils';
import { mdiClose } from '@mdi/js';
import AssetsTTS from '@/components/panel/Stickers/AssetsTTS.vue';

export default {
	components: {
		AssetsTTS
	},
	props: {
		subscribeDialog: {
			type: Boolean,
			default: false,
		},
		sticker: Object,
	},
	emits: ['onClose'],
	setup(_, ctx) {
		const store = useStore();

		const theme = computed(() => store.state.theme);
		const size = computed(() => store.state.size);
		const isMobile = computed(() => store.state.isMobile);
		const streamerDisplayName = computed(() => store.state.streamerDisplayName);

		const close = () => {
			ctx.emit('onClose');
		};

		const subscribe = () => {
			window.open(`https://www.twitch.tv/subs/${streamerDisplayName.value}`, '_blank');
			ctx.emit('onClose');
		};

		const cancelEvent = (event) => {
			event.stopImmediatePropagation();
		};

		return {
			isMobile,
			theme,
			size,
			close,
			cancelEvent,
			streamerDisplayName,
			subscribe,
			getStickerImagePath,
			icons: {
				mdiClose,
			},
		};
	},
};
</script>
